import { useDeviceStore } from "@/storeModules/devices/DeviceStore";

export const findIconByDeviceType = (deviceType: string) => {
  const deviceStore = useDeviceStore();
  if (!deviceType) return "hard-drive";
  const baseDeviceType = deviceType.split("_")[0].toUpperCase();
  const device = deviceStore.devicesList.find((d) => d.type.toUpperCase() === baseDeviceType);
  return device?.icon || "hard-drive";
};
